import CatalogPage from "@/components/feature/CatalogPage";

export default function MoviePage() {
  return (
    <CatalogPage
      type="movie"
      heading="电影频道"
      intro="免费播放片大片电影频道汇聚动作、喜剧、爱情、科幻、悬疑等各类影片资源。你可以按类型与年份筛选，并按最新、评分或热度排序，快速找到想看的那部电影。"
      breadcrumb="电影"
      metaTitle="电影频道 - 免费播放片大片 最新电影分类浏览"
      metaDescription="免费播放片大片电影频道汇聚动作、喜剧、科幻、悬疑等各类影片，支持类型与年份筛选及多种排序，轻松筛选观看。"
      metaKeywords="电影频道,免费电影,动作片,科幻电影,悬疑电影,电影分类"
    />
  );
}